import { StripeSubscriptionSummaryDto } from "@intelligems/ig-types";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLoggedInUser } from "@src/api/user-auths/login";

export const useAgencyEmailAccess = () => {
  const user = useLoggedInUser();
  const isAdmin = useIsAdmin();

  const hasAgencyEmailAccess = (
    subscription: StripeSubscriptionSummaryDto,
    hasAgencies: boolean
  ): boolean => {
    if (isAdmin) return true;

    if (!hasAgencies) return true;

    if (!subscription.agencyEmails?.length) return false;

    return subscription.agencyEmails.some(
      (email) => email === user.data?.user?.email
    );
  };

  return { hasAgencyEmailAccess };
};
